import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs"

export const topicsAddApi = createAsyncThunk(
    'auth/topics/add',
    async (data, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.post(apiRoutes.topicsList, data)
            return response?.data
        } catch (error) {
            // return rejectWithValue(error?.response?.data)
            console.log("err", error)
        }
    }
)

const topicsAddSlice = createSlice({
    name: 'Topics Add',
    initialState: { result: [], loading: false, error: null, message: "" },
    extraReducers: (builder) => {
        builder.addCase(topicsAddApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(topicsAddApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
        })
        builder.addCase(topicsAddApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})

export const topicsAddReducer = topicsAddSlice.reducer